module.exports = __webpack_public_path__ + "static/media/YMLATJSONBSOTK2.802fa7d0.png";